import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const DIGILOCKER_API_URL =
  'https://kyc-api.surepass.app/api/v1/digilocker/download-aadhaar';

const Callback = () => {
  const navigate = useNavigate();

  const hasFetchedRef = useRef(false);


  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    const token = localStorage.getItem('bgc_token');
    const clientID = localStorage.getItem('client_id');


    if (!clientID) {
      toast.error('DigiLocker verification failed or cancelled');
      navigate('/candidate/digilocker-router', { replace: true });
      return;
    }

    const fetchAndStoreAadhaarData = async () => {
      try {
        const response = await fetch(
          `${DIGILOCKER_API_URL}/${clientID}`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc1MTA4NzkxNywianRpIjoiOTk0MWMzMGUtNGY4Ny00NTNkLWE0OTEtODNkNmZiNDE0OGEzIiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LnVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsIm5iZiI6MTc1MTA4NzkxNywiZXhwIjoyMzgxODA3OTE3LCJlbWFpbCI6InVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.HJHPVrHRTVD0wwXiiI226F7A7r_fIAjMvVaChKoc6W8`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(
            errorData.message ||
              `Failed to fetch Aadhaar data. Status: ${response.status}`
          );
        }

        const result = await response.json();

        toast.success('DigiLocker verification successful. Data loaded.', {
          autoClose: 3000,
        });

        const aadhaarData = result.data?.aadhaar_xml_data;
        const digilockerMetadata = result.data?.digilocker_metadata;
        const addressData = aadhaarData?.address;

        if (!result.success || !aadhaarData) {
          throw new Error(
            result.message || 'Aadhaar data was not successfully retrieved.'
          );
        }

        // ---------- Personal Info ----------
        let firstName = aadhaarData.full_name;
        let lastName = '';

        const nameParts = firstName.split(' ');
        if (nameParts.length > 1) {
          firstName = nameParts.slice(0, -1).join(' ');
          lastName = nameParts[nameParts.length - 1];
        }

        const personalData = {
          first_name: firstName,
          last_name: lastName,
          care_of: aadhaarData.care_of,
          dob: aadhaarData.dob,
          mobile_number: digilockerMetadata?.mobile_number || '',
          gender: digilockerMetadata?.gender || aadhaarData.gender,
          aadhaar_number: aadhaarData.masked_aadhaar,
          profile_image: aadhaarData.profile_image,
        };

        // ---------- Address Info ----------
        const address_response = {
          country: addressData?.country,
          dist: addressData?.dist,
          state: addressData?.state,
          city: addressData?.po,
          surePassZip: aadhaarData.zip,
          street: addressData?.street,
          loc: addressData?.loc,
          subdist: addressData?.subdist,
          vtc: addressData?.vtc,
          house: addressData?.house,
        };

        // ---------- Store ----------
        localStorage.setItem('personalData', JSON.stringify(personalData));
        localStorage.setItem(
          'address_response',
          JSON.stringify(address_response)
        );
        localStorage.setItem('aadhaarDataFetched', 'true');


         navigate('/candidate/personal-info', { replace: true });
      } catch (err) {
        console.error('Error fetching DigiLocker data:', err);
        toast.error(err.message || 'DigiLocker data retrieval failed.');
        navigate('/login', { replace: true });
      }
    };

    fetchAndStoreAadhaarData();
  }, [navigate]);

  return null;
};

export default Callback;
